import wangsagria1 from "./wangsagria (1).jpeg";
import wangsagria2 from "./wangsagria (2).jpeg";
import wangsagria3 from "./wangsagria (3).jpeg";
import wangsagria4 from "./wangsagria (4).jpeg";
import wangsagria5 from "./wangsagria (5).jpeg";
import wangsagria6 from "./wangsagria (6).jpeg";
import wangsagria7 from "./wangsagria (7).jpeg";
import wangsagria8 from "./wangsagria (8).jpeg";
import wangsagria9 from "./wangsagria (9).jpeg";
import wangsagria10 from "./wangsagria (10).jpeg";
import wangsagria11 from "./Screenshot_2.webp";

const wangsariyaimg = [
  wangsagria1,
  wangsagria2,
  wangsagria3,
  wangsagria4,
  wangsagria5,
  wangsagria6,
  wangsagria7,
  wangsagria8,
  wangsagria9,
  wangsagria10,
  wangsagria11,
];

export default wangsariyaimg;
